import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { Button, Card, Col, DropdownItem, DropdownMenu, DropdownToggle, Row, UncontrolledDropdown } from "reactstrap";
import { emailReport } from "../../../api/reports";
import { userPreferenceSave, userPreferencesGetList } from "../../../api/userPreferences";
import { features, isFeatureEnabled } from "../../../config";
import { logEvent } from "../../../helpers/ga";
import useWindowSize from "../../../hooks/useWindowSize";
import local from "../../../localization/strings";
import EmailModal from "../../common/EmailModal";
import PageTitle from "../../common/PageTitle";
import AlarmReportDisplay from "./AlarmReportDisplay";
import AlarmReportFilter from "./AlarmReportFilter";

const buttonDefaultClasses = "btn-shadow btn-sm mb-sm-2 py-2 px-2 px-sm-3 py-sm-1";

const AlarmReport = () => {
	const [showFilter, setShowFilter] = useState(true);
	const [reportRunning, setReportRunning] = useState(false);
	const [data, setData] = useState({});
	const [report, setReport] = useState(undefined);
	const [showEmail, setShowEmail] = useState(false);
	const size = useWindowSize();

	const generateStats = async (data) => {
		await userPreferenceSave("AlarmReport_Filter", JSON.stringify(data));

		setReportRunning(true);
		setData(data);
		setShowFilter(false);
	};

	const filter = () => {
		logEvent("Alarm Report", "Filter");

		setShowFilter(true);
	};

	useEffect(() => {
		const LoadData = async () => {
			const prefs = await userPreferencesGetList();

			var match = prefs.find((x) => x.preferenceKey === "AlarmReport_Filter");

			if (match) {
				setData(JSON.parse(match.preferenceValue));
			}
		};

		LoadData();
	}, []);

	const reportComplete = useCallback((report) => {
		setReport(report);
		setReportRunning(false);
	}, []);

	const csvHeaders = (reportData) => {
		return reportData.columns.map((item) => ({ label: item.name, key: item.key }));
	};

	useEffect(() => {
		var dashboardContentDiv = document.getElementById("dashboard-container-div");

		if (dashboardContentDiv) {
			var contentDiv = document.getElementById("toolbar-row");
			contentDiv.style.marginRight = `-${dashboardContentDiv.offsetLeft}px`;
		}
	}, [size]);

	const toggleEmailModal = () => {
		setShowEmail(!showEmail);
	};

	const sendEmail = async (to, subject, body) => {
		logEvent("Alarm Report", "Send Email");

		emailReport("Alarm Report", data, to, subject, body);

		setShowEmail(false);
	};

	return (
		<>
			<PageTitle title={local.TS_AlarmHistoryReport} />

			<Row id="toolbar-row" className="justify-content-between">
				{showFilter ? (
					""
				) : (
					<>
						<Col className="col-3">
							<Button size="sm" color="secondary" className={buttonDefaultClasses} onClick={() => filter()}>
								<FontAwesomeIcon icon="filter" />
								<span className="d-none d-md-inline-block ml-2">{local.TS_Filter}</span>
							</Button>
						</Col>
						<Col className="col-3 p-0">
							<UncontrolledDropdown size="sm" direction="left" className="allow-overflow float-right">
								<DropdownToggle caret color="info" transform="shrink-3" className={buttonDefaultClasses} disabled={reportRunning}>
									<FontAwesomeIcon icon="share-alt" />
									<span className="d-none d-md-inline-block ml-2">{local.TS_Options}</span>
								</DropdownToggle>
								<DropdownMenu className="menu-border-blue dropdown-menu">
									{/* v0.9 */}
									<DropdownItem>
										{report && (
											<CSVLink className="w-100 d-block" data={report.rows} headers={csvHeaders(report)} filename={`${local.TS_AlarmHistoryReport} ${moment().format("DD MMM YYYY")}.csv`}>
												<FontAwesomeIcon icon="download" /> {local.TS_Download}
											</CSVLink>
										)}
									</DropdownItem>
									{isFeatureEnabled(features.ReportEmail) && (
										<DropdownItem onClick={() => toggleEmailModal()}>
											<FontAwesomeIcon icon="envelope-square" /> {local.TS_Email}
										</DropdownItem>
									)}
								</DropdownMenu>
							</UncontrolledDropdown>
						</Col>
					</>
				)}
			</Row>
			<Card className="p-3" id="alarm-report-div">
				{showFilter ? <AlarmReportFilter triggerGenerate={generateStats} filterData={data} /> : <AlarmReportDisplay filterData={data} reportComplete={reportComplete} />}
			</Card>
			<EmailModal show={showEmail} cancel={() => setShowEmail(false)} sendEmail={sendEmail} />
		</>
	);
};

export default AlarmReport;
